import { Close } from "@carbon/icons-react";
import { Button, Popover } from "@mui/material";
import { useState } from "react";

import "./IconButtonWithPopover.scss";

interface IconButtonWithPopoverProps {
  title: string;
  buttonIcon: JSX.Element;
  className?: string;
}

const IconButtonWithPopover = (
  props: React.PropsWithChildren<IconButtonWithPopoverProps>,
) => {
  const { title, buttonIcon, className, children } = props;

  const [anchorElement, setAnchorElement] = useState<HTMLButtonElement | null>(
    null,
  );

  const popupOpen = Boolean(anchorElement);
  const id = popupOpen ? "simple-popover" : undefined;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorElement(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorElement(null);
  };

  return (
    <div className={className}>
      <Button
        data-testid="popoverButton"
        id="popoverButton"
        onClick={handleClick}
      >
        {buttonIcon}
      </Button>
      <Popover
        className="popup"
        data-testid="popover"
        id={id}
        open={popupOpen}
        onClose={handleClose}
        anchorEl={anchorElement}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <div className="popup-header">
          <div className="popup-header-label">{title}</div>
          <div
            data-testid="closePopover"
            className="popup-header-button"
            onClick={handleClose}
          >
            <Close size={24} />
          </div>
        </div>
        {children}
      </Popover>
    </div>
  );
};
export default IconButtonWithPopover;
